<template>
  <h3>FADES Specification Editor</h3>
  <nav>
    <!-- <router-link to="/">Home</router-link> | -->
    <router-link to="/pds">PDS</router-link> |
    <router-link to="/ups">UPS</router-link> |
    <router-link to="/about">About</router-link>
  </nav>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #deac23;
}
</style>
